import React from 'react'
import { links, constants } from 'common/helpers'
import cx from 'classnames'

import Product from './Product/Product'
import Label from './Label/Label'

import messages from './messages'
import s from './Month.scss'


const QueueMonth = (props) => {
  const {
    viewOnly, data, square,
    isOnboardingTourItem, isQueueEmptyPlusCellEnabled, isQueueEmptyFirstCellPlusEnabled,
    onClick, onRemove, onTrackingNumberClick, onBlur, onFocus, onKeyDown,
    ariaDescribedby,
  } = props

  const { date, skipped, locked, products, status, shipped, tracking, paused, disabled } = data

  const isLocked    = locked || shipped && !tracking
  const statusSize  = status.filter((statusName) => [ 'skipped', 'locked', 'paused' ].includes(statusName)).length

  const isMultipleProductPlan = status.length > 1

  let labelText

  if (skipped) {
    labelText = messages.skipped
  }
  if (isLocked) {
    labelText = messages.locked
  }
  if (paused) {
    labelText = messages.paused
  }

  let trackingLinkProps = {}

  if (tracking) {
    trackingLinkProps = {
      to: links.tracking,
    }
  }

  // Added id for Onboarding Tour
  const contentId = isOnboardingTourItem ? 'onboard_step1' : null

  const rootClassName = cx(s.monthContainer, {
    [s.oneProduct]: status.length === 1,
    [s.twoProduct]: status.length === 2,
    [s.threeProduct]: status.length === 3 || status.length === 4,
    [s.skipped]: skipped,
    [s.disabled]: disabled,
    [s.multipleProductPlan]: isMultipleProductPlan,
  })

  return (
    <div className={rootClassName}>
      <div className={cx(s.month, { [s.monthSquare]: square })}>
        <div className={s.content} id={contentId} data-testid={constants.testIds.queue.month}>
          {
            Boolean(labelText && !viewOnly) && (
              <Label
                columns={status.length}
                size={statusSize}
                message={labelText}
              />
            )
          }
          {
            Boolean(tracking && !viewOnly) && (
              <Label
                message={messages.trackingNumber}
                linkProps={trackingLinkProps}
                onClick={onTrackingNumberClick}
              />
            )
          }
          {
            <div className={s.products}>
              {
                products.map((product, index) => {
                  const productProps = {
                    data: product,
                    viewOnly,
                    isMultipleProductPlan,
                    onBlur,
                    onFocus,
                    onClick,
                    onRemove,
                    onKeyDown,
                    isQueueEmptyPlusCellEnabled,
                    isQueueEmptyFirstCellPlusEnabled,
                    square,
                    date,
                    ariaDescribedby,
                  }

                  return (
                    <Product key={index} {...productProps} />
                  )
                })
              }
            </div>
          }
        </div>
        <div className={s.date}>{date.format('MMM YYYY')}</div>
      </div>
    </div>
  )
}


export default QueueMonth
